const { savePending, sendPending } = require('../monitors/session-replay');

const getRequestIdleCallback = window.requestIdleCallback || ((callback) => setTimeout(callback, 200));

const eventName = 'sessionReplayEvent';

const subscribeToPageUnload = () => {
  const sessionReplayEventHandler = async () => {
    if (window.document.visibilityState === 'hidden') {
      savePending();
    }

    if (window.document.visibilityState === 'visible') {
      sendPending();
    }
  };

  // TODO - listen to pagehide on safari? https://developer.mozilla.org/en-US/docs/Web/API/Document/visibilitychange_event
  window.document.addEventListener(eventName, sessionReplayEventHandler);

  const sessionReplayChangeHandler = () => {
    const event = new window.Event(eventName);
    window.document.dispatchEvent(event);
  };

  // detect page visibility change
  window.document.addEventListener(
    'visibilitychange',
    sessionReplayChangeHandler,
  );
};

const setSessionReplayHandler = () => {
  subscribeToPageUnload();
};

const trigger = () => {
  getRequestIdleCallback(() => setSessionReplayHandler());
};

module.exports = trigger;
